// 'window.load' ko hata kar humne direct function chalaya hai
// hero section
(function() {
    const hero = document.querySelector('.mobile-showroom-btn');

    if (hero) {
        // Transition pehle hi set kar dein
        hero.style.transition = "opacity 0.8s ease-out, transform 0.8s ease-out";
        
        // 50ms ka bilkul chota sa delay taake browser ko animation trigger karne ka waqt mile
        setTimeout(() => {
            hero.style.setProperty('opacity', '1', 'important');
            hero.style.setProperty('transform', 'translateX(0)', 'important');
            hero.style.setProperty('visibility', 'visible', 'important');
        }, 50); 
    }
})();

//3 images section 

document.addEventListener("DOMContentLoaded", function() {
    const images = document.querySelectorAll('.mobile-showroom-img');
    
    const observerOptions = {
        root: null, // browser viewport
        threshold: 0.2 // Jab 20% section nazar aaye tab shuru ho
    };

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Thora sa wait kar ke bari bari animate karein
                setTimeout(() => {
                    images.forEach((img, index) => {
                        setTimeout(() => {
                            img.classList.add('show-now');
                        }, index * 250); // 0.25s ka gap har image ke darmiyan
                    });
                }, 100);
                
                // Ek baar animation ho jaye to dobara check na kare (Performance fix)
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    // Poore section ya pehli image ko observe karein
    if (images.length > 0) {
        // Hum pehli image ke container ko target kar rahe hain
        observer.observe(images[0].parentElement); 
    }
});

// viedo and text

document.addEventListener("DOMContentLoaded", function() {
    const textElement = document.querySelector('.mobile-showroom-text-content');
    
    const observerOptions = {
        root: null,
        threshold: 0.8 // Jab 20% section nazar aaye tab chal jaye
    };

    const textObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Animation shuru karein
                textElement.classList.add('animate-in');
                
                // Sab se important: Ek baar animation chal gayi, to ab check karna band kar do
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    if (textElement) {
        // Hum text ke parent ko observe kar rahe hain behtar trigger ke liye
        textObserver.observe(textElement.parentElement);
    }
});

// image and text
(function() {
    function triggerSplitAnimation() {
        const textSide = document.querySelector('.mobile-showroom-text-icon');
        const imageSide = document.querySelector('.mobile-showroom-img-text');
        
        // Agar koi ek bhi element mil jaye to logic shuru karein
        const target = textSide || imageSide;
        if (!target) return;

        const rect = target.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;

        // Jab section screen ke 75% hisse par pohanche
        if (rect.top <= windowHeight * 0.75) {
            if (textSide) textSide.classList.add('animate-now');
            if (imageSide) imageSide.classList.add('animate-now');

            // Ek baar ho gaya, ab scroll listener ki zaroorat nahi
            window.removeEventListener('scroll', triggerSplitAnimation);
        }
    }

    // Scroll aur Load dono par nazar rakhein
    window.addEventListener('scroll', triggerSplitAnimation);
    window.addEventListener('load', triggerSplitAnimation);
    
    // Check foran (agar page refresh usi jagah par ho)
    triggerSplitAnimation();
})();

// Viedo
(function() {
    function triggerAllVideos() {
        // querySelectorAll se saaray videos select karein
        const allVideos = document.querySelectorAll('.mobile-showroom-viedo');
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;

        allVideos.forEach((video) => {
            // Agar ye wala video pehle hi animate ho chuka hai to skip karein
            if (video.classList.contains('video-reveal')) return;

            const rect = video.getBoundingClientRect();

            // Jab ye wala specific video screen par aaye
            if (rect.top <= windowHeight * 0.75) {
                video.classList.add('video-reveal');

                // Video ko play karne ki koshish
                const actualVideo = video.querySelector('video') || video;
                if (actualVideo && typeof actualVideo.play === 'function') {
                    actualVideo.play().catch(e => console.log("Autoplay pending..."));
                }
            }
        });

        // Agar saaray videos animate ho gaye hain to listener hata dein
        const animatedCount = document.querySelectorAll('.mobile-showroom-viedo.video-reveal').length;
        if (animatedCount === allVideos.length && allVideos.length > 0) {
            window.removeEventListener('scroll', triggerAllVideos);
        }
    }

    window.addEventListener('scroll', triggerAllVideos);
    window.addEventListener('load', triggerAllVideos);
    triggerAllVideos(); // Foran check karein
})();


document.addEventListener('DOMContentLoaded', function() {
  const buttons = document.querySelectorAll('.form-pop-up-btn');
  const section = document.querySelector('.vertical-breather');

  // 1. Function jo HTML inject karega aur events lagayega
  function injectCloseButton(formDiv) {
    if (!document.querySelector('.close-form-popup')) {
      formDiv.insertAdjacentHTML('beforeend', '<div class="close-form-popup">×</div>');
      
      const closeBtn = document.querySelector('.close-form-popup');
      closeBtn.addEventListener('click', function() {
        section.classList.remove('is-active');
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
      });
      console.log("Success: Close button injected!");
    }
  }

  // 2. Element ka intezar karne wala logic (Polling)
  const checkFormExist = setInterval(function() {
    const formDiv = document.querySelector('.form_generater_form_div');
    if (formDiv) {
      injectCloseButton(formDiv);
      // clearInterval(checkFormExist); // Agar aap chahte hain ke sirf ek baar chale
      // Lekin Hulk form refresh hota hai, isliye hum isay chalne denge ya observer lagayenge
    }
  }, 500); // Har half-second baad check karega

  // 3. Open Button Logic
  if (section && buttons.length > 0) {
    buttons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        section.classList.add('is-active');
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
      });
    });

    // Outside click logic
    section.addEventListener('click', function(e) {
      if (e.target === section) {
        section.classList.remove('is-active');
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
      }
    });
  }
});